<template>
  <div class="warning-info">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'specialAlert',
  data () {
    return {
      id: 'specialAlert'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.warning-info {
  line-height: 25px ;
  white-space: normal;
  font-size: 12px;
  padding: 6px 16px;
  border-radius: 14px;
  color: $assertive;
  border: 1px solid $assertive;
  position: relative;
  z-index: 0;
  &:before {
    content: ' ';
    width: 0;
    height: 0;
    border-width: 0 6PX 6PX;
    border-style: solid;
    border-color: transparent transparent $assertive;
    position: absolute;
    top: -6PX;
    left: 30PX;
  }
  &:after {
    content: ' ';
    width: 0;
    height: 0;
    border-width: 0 6PX 6PX;
    border-style: solid;
    border-color: transparent transparent #fff;
    position: absolute;
    top: -5PX;
    left: 30PX;
  }
}
</style>
